import getPlatform from '@/utils/getPlatform'
import { useEffect, useState } from 'react'

const usePlatform = (): string => {
  const [userPlatform, setPlatform] = useState<string>('')

  useEffect(() => {
    setPlatform(getPlatform())
  }, [])

  return userPlatform
}

export default usePlatform
